import type { LayoutLoad } from "./$types";
import { browser } from "$app/environment";

export const load = (async ({ data, url }) => {
  const source = new URL(url).searchParams.get("utm_source");
  const record_prefix = ["sf-", "hub-"];
  if (
    browser && source &&
    record_prefix.some((prefix) => source.startsWith(prefix))
  ) {
    // const loadPosthog = await import("posthog-js");
    // loadPosthog.posthog.init(
    //   "phc_xjBLcQ28k8zFWsTwGh3V38m836N0JcDaANsOhFIiaGb",
    //   {
    //     api_host: "https://us.i.posthog.com",
    //     disable_session_recording: false,
    //     person_profiles: "always",
    //     capture_pageview: true,
    //     capture_pageleave: true,
    //   },
    // );
  }
  return {
    ...data,
  };
}) satisfies LayoutLoad;
